import type { SuburbInput } from "@repo/adapter-core";
import { buildQueryPaginatedUrl, slugify } from "@repo/adapter-core";
import type { AllhomesAdapterConfig } from "./config.ts";

export function buildSearchUrl(suburb: SuburbInput, config: AllhomesAdapterConfig): string {
  const listingPath =
    config.listingType === "rent" ? "/rent/" : config.listingType === "buy" ? "/sale/" : "/sold/";
  const baseUrl = `https://www.allhomes.com.au${listingPath}${slugify(suburb.locality)}-${suburb.state.toLowerCase()}-${suburb.postcode}/`;
  const params = new URLSearchParams();
  // Allhomes only documents `sort=latest`. There's no explicit
  // `sort=date_desc` or `soldwithin` parameter — Allhomes ignores both
  // (verified manually via the website's URL after applying filters).
  // The discovery-stage preview-card date guard (Phase 3) is what
  // actually enforces the window for this adapter.
  params.set("sort", config.sortBy || "latest");
  return `${baseUrl}?${params.toString()}`;
}

/**
 * Allhomes uses query-param pagination: `?page=2`. The site canonicalises
 * the first page by dropping the `page` param entirely, so for page 1 we
 * return the original `?sort=latest` URL untouched.
 */
export function buildPaginatedUrl(searchUrl: string, page: number): string {
  return buildQueryPaginatedUrl(searchUrl, page);
}
